import store from "@/store"

export default {
    base(id: string, value: string, min: number = 0, max: number = -1, required: boolean = false) {
        const values = store.state.error.errors[id] ?? [];
        if (value.length == 0 && required) values.push(`The ${id} field is required.`);
        if (value.length < min) values.push(`The ${id} field must be at least ${min} characters.`)
        else if (max != -1 && value.length > max) values.push(`The ${id} must not be greater than ${max} characters.`)
        store.state.error.errors[id] = values;
    },
    email(id: string, value: string) {
        const expr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const values = store.state.error.errors[id] ?? [];
        if (!expr.test(value)) values.push(`The ${id} must be a valid email address.`)
        store.state.error.errors[id] = values;
    },
    valid(id: string): boolean {
        return this.get(id).length < 1;
    },
    get(id: string): string[] {
        return store.state.error.errors[id] ?? [];
    },
    clear(id: string) {
        delete store.state.error.errors[id];
    },
    match(first: string, second: string, firstValue: string, secondValue: string) {
        const values = store.state.error.errors[second] ?? [];
        if (firstValue !== secondValue) {
            values.push(`The value of ${second} must match ${first}`)
        }
        store.state.error.errors[second] = values;
    },
    isInteger(value: string) {
        return /^\d+$/.test(value)
    }

}
